<div class="page-layout simple inner-scroll">
    <!-- HEADER -->
    <div class="header accent p-6 flex items-center">
        <div>
            <span class="text-4xl font-semibold">API Keys / Integraciones</span>
        </div>
    </div>
    <!-- / HEADER -->
    <div class="content p-6 flex flex-col gap-6">
        <p class="max-w-3xl">
            Las API keys permiten que agentes IA (MCP) y sistemas de terceros consulten la información de YPM
            (ExternalAPI) con los mismos permisos y visibilidad que su usuario. Trate cada clave como una contraseña.
        </p>

        <!-- NUEVA KEY -->
        <form [formGroup]="form" (ngSubmit)="create()" class="flex items-end gap-4 flex-wrap">
            <mat-form-field appearance="outline" class="w-80">
                <mat-label>Nombre</mat-label>
                <input matInput formControlName="name" placeholder="Ej: Claude - notebook">
            </mat-form-field>
            <mat-form-field appearance="outline" class="w-56">
                <mat-label>Expira (opcional)</mat-label>
                <input matInput type="date" formControlName="expiresAt">
            </mat-form-field>
            <button mat-raised-button color="accent" type="submit" [disabled]="form.invalid" class="mb-5">
                <mat-icon>vpn_key</mat-icon>
                <span>Crear API key</span>
            </button>
        </form>

        <!-- KEY RECIEN CREADA -->
        <div *ngIf="createdKey" class="border rounded p-4 bg-yellow-50 max-w-4xl">
            <div class="font-semibold mb-2">Copie la clave ahora: no se volverá a mostrar.</div>
            <div class="flex items-center gap-2">
                <code class="p-2 bg-white border rounded break-all flex-grow">{{createdKey.key}}</code>
                <button mat-icon-button type="button" (click)="copy(createdKey.key)" matTooltip="Copiar clave">
                    <mat-icon>content_copy</mat-icon>
                </button>
            </div>
        </div>

        <!-- CONEXION MCP -->
        <div class="max-w-4xl">
            <div class="font-semibold mb-2">Conectar un agente IA (MCP)</div>
            <div class="mb-2">URL del servidor MCP: <code>{{mcpUrl}}</code>. Ejemplo con Claude Code:</div>
            <div class="flex items-center gap-2">
                <code class="p-2 bg-gray-100 border rounded break-all flex-grow">{{mcpCommand}}</code>
                <button mat-icon-button type="button" (click)="copy(mcpCommand)" matTooltip="Copiar comando">
                    <mat-icon>content_copy</mat-icon>
                </button>
            </div>
        </div>

        <!-- CONECTOR OAUTH (Claude.ai, ChatGPT, etc.) -->
        <div class="max-w-4xl">
            <div class="font-semibold mb-2">Conectar desde Claude.ai u otras aplicaciones (sin API key)</div>
            <div>
                En Claude.ai o la app de escritorio: <em>Configuración &rarr; Conectores &rarr; Agregar conector personalizado</em>,
                con la URL <code>{{mcpUrl}}</code>. La aplicación le va a pedir que inicie sesión en YPM y autorice el acceso.
            </div>
        </div>

        <!-- APLICACIONES CONECTADAS -->
        <div class="max-w-5xl">
            <div class="font-semibold mb-2">Aplicaciones conectadas (OAuth)</div>
            <div *ngIf="grants.length === 0" class="text-gray-600">No hay aplicaciones conectadas.</div>
            <table *ngIf="grants.length > 0" class="w-full text-left border-collapse">
                <thead>
                    <tr class="border-b">
                        <th class="py-2 pr-4">Aplicación</th>
                        <th class="py-2 pr-4">Conectada</th>
                        <th class="py-2 pr-4">Último uso</th>
                        <th class="py-2 pr-4">Vence</th>
                        <th class="py-2"></th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let grant of grants" class="border-b">
                        <td class="py-2 pr-4">{{grant.clientName}}</td>
                        <td class="py-2 pr-4">{{grant.createdAt | date:'dd/MM/yyyy HH:mm'}}</td>
                        <td class="py-2 pr-4">{{grant.lastUsedAt ? (grant.lastUsedAt | date:'dd/MM/yyyy HH:mm') : '-'}}</td>
                        <td class="py-2 pr-4">{{grant.expiresAt | date:'dd/MM/yyyy'}}</td>
                        <td class="py-2">
                            <button mat-button color="warn" type="button" (click)="revokeGrant(grant)">Revocar</button>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>

        <!-- LISTADO -->
        <div class="max-w-5xl">
            <div class="font-semibold mb-2">Mis API keys</div>
            <div *ngIf="keys.length === 0" class="text-gray-600">No tiene API keys creadas.</div>
            <table *ngIf="keys.length > 0" class="w-full text-left border-collapse">
                <thead>
                    <tr class="border-b">
                        <th class="py-2 pr-4">Nombre</th>
                        <th class="py-2 pr-4">Clave</th>
                        <th class="py-2 pr-4">Creada</th>
                        <th class="py-2 pr-4">Último uso</th>
                        <th class="py-2 pr-4">Expira</th>
                        <th class="py-2 pr-4">Estado</th>
                        <th class="py-2"></th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let apiKey of keys" class="border-b">
                        <td class="py-2 pr-4">{{apiKey.name}}</td>
                        <td class="py-2 pr-4"><code>{{apiKey.prefix}}…</code></td>
                        <td class="py-2 pr-4">{{apiKey.createdAt | date:'dd/MM/yyyy HH:mm'}}</td>
                        <td class="py-2 pr-4">{{apiKey.lastUsedAt ? (apiKey.lastUsedAt | date:'dd/MM/yyyy HH:mm') : '-'}}</td>
                        <td class="py-2 pr-4">{{apiKey.expiresAt ? (apiKey.expiresAt | date:'dd/MM/yyyy') : '-'}}</td>
                        <td class="py-2 pr-4">{{apiKey.revoked ? 'Revocada' : (apiKey.active ? 'Activa' : 'Expirada')}}</td>
                        <td class="py-2">
                            <button *ngIf="!apiKey.revoked" mat-button color="warn" type="button" (click)="revoke(apiKey)">
                                Revocar
                            </button>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</div>
